(function() {
  'use strict';

  var cartSelector = '[data-dawn-cart]';
  var removeSelector = '[data-dawn-cart-remove]';

  function getCartRoot() {
    return document.querySelector(cartSelector);
  }

  function getCartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + path.replace(/^\//, '');
  }

  function readResponse(response) {
    return response.json().then(function(data) {
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Cart request failed');
      }
      return data;
    });
  }

  function updateHeaderCount(itemCount) {
    var count = document.getElementById('CartCount');
    if (!count) return;

    if (itemCount < 1) {
      count.parentNode.removeChild(count);
      return;
    }

    var visibleCount = count.querySelector('span');
    var hiddenCount = count.querySelector('.icon__fallback-text');
    if (visibleCount) visibleCount.textContent = itemCount;
    if (hiddenCount) hiddenCount.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
  }

  function captureFormState(cart) {
    var quantities = {};
    cart.querySelectorAll('.cart__qty-input[id]').forEach(function(input) {
      quantities[input.id] = input.value;
    });

    var note = cart.querySelector('[name="note"]');
    return {
      note: note ? note.value : null,
      quantities: quantities
    };
  }

  function restoreFormState(cart, state) {
    Object.keys(state.quantities).forEach(function(id) {
      var input = document.getElementById(id);
      if (input && cart.contains(input)) input.value = state.quantities[id];
    });

    var note = cart.querySelector('[name="note"]');
    if (note && state.note !== null) note.value = state.note;
  }

  function renderCart(cart, html, cartData, productTitle, buttonIndex, scrollTop, formState) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var incoming = parsed.querySelector(cartSelector);
    if (!incoming) throw new Error('Cart section could not be refreshed');

    cart.innerHTML = incoming.innerHTML;
    restoreFormState(cart, formState);
    updateHeaderCount(cartData.item_count);

    var status = cart.querySelector('[data-dawn-cart-status]');
    if (status) {
      status.textContent = (cart.dataset.removeSuccess || 'Removed [product] from your cart.').replace('[product]', productTitle);
    }

    var buttons = cart.querySelectorAll(removeSelector);
    var focusTarget = buttons[Math.min(buttonIndex, Math.max(0, buttons.length - 1))];
    if (!focusTarget) {
      focusTarget = cart.querySelector('h1');
      if (focusTarget) focusTarget.setAttribute('tabindex', '-1');
    }

    window.requestAnimationFrame(function() {
      var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo(0, Math.min(scrollTop, maxScroll));
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });
  }

  function showError(cart, button, row, message) {
    cart.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    if (row) row.classList.remove('is-removing');

    var error = cart.querySelector('[data-dawn-cart-error]');
    if (error) {
      error.textContent = message || cart.dataset.removeError || "We couldn't remove that item. Please try again.";
      error.hidden = false;
    }
  }

  function removeLine(cart, button) {
    if (cart.getAttribute('aria-busy') === 'true') return;

    var line = Number(button.dataset.line);
    if (!line) return;

    var row = button.closest('[data-cart-line-row]');
    var buttons = Array.prototype.slice.call(cart.querySelectorAll(removeSelector));
    var buttonIndex = Math.max(0, buttons.indexOf(button));
    var scrollTop = window.pageYOffset;
    var productTitle = button.dataset.productTitle || '';
    var formState = captureFormState(cart);
    var error = cart.querySelector('[data-dawn-cart-error]');
    var cartChanged = false;

    if (error) error.hidden = true;
    cart.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    if (row) row.classList.add('is-removing');

    fetch(getCartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(readResponse)
      .then(function(cartData) {
        cartChanged = true;
        var sectionUrl = getCartUrl('cart?section_id=' + encodeURIComponent(cart.dataset.sectionId));
        return fetch(sectionUrl, { credentials: 'same-origin' }).then(function(response) {
          if (!response.ok) throw new Error('Cart section could not be refreshed');
          return response.text();
        }).then(function(html) {
          renderCart(cart, html, cartData, productTitle, buttonIndex, scrollTop, formState);
          cart.removeAttribute('aria-busy');
        });
      })
      .catch(function(error) {
        if (cartChanged) {
          window.location.reload();
          return;
        }
        showError(cart, button, row, error.message);
      });
  }

  function init() {
    var cart = getCartRoot();
    if (!cart || cart.dataset.dawnCartInitialized === 'true') return;
    if (!window.fetch || !window.DOMParser) return;

    cart.dataset.dawnCartInitialized = 'true';
    cart.addEventListener('click', function(event) {
      var button = event.target.closest(removeSelector);
      if (!button || !cart.contains(button)) return;

      event.preventDefault();
      removeLine(cart, button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
